import { v4 as uuidv4 } from 'uuid';
import { CreateVariant } from '../../../MasterTabsProvider';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { LotDataProvider } from '../../../../Services/DataProviders/LotDataProvider';
import useLockingDocuments from '../../../../components/lockDocuments/useLockingDocuments';
import { IdTableVariant } from '../../../../@types/enumsGlobal';
import { InvoiceCashOrderCreatorView } from '../view/InvoiceCashOrderCreatorView';
import InvoiceCashOrderGridPluginSettings from '../pluginSettings/InvoiceCashOrderGridPluginSettings';

export const InvoiceCashOrderCreatorTab = (idGlobal: string, variant?: CreateVariant, parentCallback?: <T>(message: T) => void, mnemocode?: any): ITab => {
    const appContext = useAppContext();
    const lotDP = new LotDataProvider(appContext.coreApiService)
    const checkCopyTabVariantId = variant === 'edit' && idGlobal !== undefined ? idGlobal : uuidv4();
    const titleTab = mnemocode ? `Приходный кассовый ордер ${mnemocode}` : 'Приходный кассовый ордер'
    const lockingDocuments = useLockingDocuments();

    return {
        id: checkCopyTabVariantId,
        title: titleTab,
        plugin: 'invoice_cash_order_create_plugin',
        mnemocode: mnemocode,
        closeWarning: true,
        onTabClosed: () => {
            lotDP.deleteOnlineReserve(idGlobal as string, () => { });
            lockingDocuments.delete({
                idTable: IdTableVariant.InvoiceCashOrder,
                idDocument: idGlobal as string,
            });
        },
        view: {
            content: InvoiceCashOrderGridPluginSettings
                ? <InvoiceCashOrderCreatorView variant={variant ?? 'create'} idGlobal={idGlobal} createdCallback={parentCallback} permission={InvoiceCashOrderGridPluginSettings.permission as IPermission} />
                : <p> Справочник не настроен </p>
        }
    }
}